import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Accordion } from "@shared/components";

import { PendingAlreadyReviewedListItem } from "./components";

import type { CarouselError } from "../pendencies-carousel/pendencies-carousel.type";
import type { PendingAlreadyReviewedListProps } from "./pending-already-reviewed-list.type";
import styles from "./pending-already-reviewed-list.module.css";

const ACCORDION_ACCEPTED_ID = "accepted-items";
const ACCORDION_SKIPPED_ID = "skipped-items";

export const PendingAlreadyReviewedList = ({
  accepted,
  skipped,
  onRemoveItem,
}: PendingAlreadyReviewedListProps) => {
  const { t } = useTranslation();
  const [activeItems, setActiveItems] = useState<string[]>([
    ACCORDION_ACCEPTED_ID,
    ACCORDION_SKIPPED_ID,
  ]);

  const renderHeader = (label: string, count: number) => (
    <span className={styles["accordion-left"]}>
      <span className={styles["accordion-label"]}>{label}</span>
      <span className={styles["accordion-count"]}>{count}</span>
    </span>
  );

  const renderBody = (items: CarouselError[], emptyLabel: string, isSkipped: boolean) => (
    <div className={styles["accordion-body"]}>
      {items.length === 0 ? (
        <p className={styles["accordion-empty"]}>{emptyLabel}</p>
      ) : (
        [...items].reverse().map((item) => (
          <PendingAlreadyReviewedListItem
            key={item.key}
            item={item}
            isSkipped={isSkipped}
            onRemove={onRemoveItem}
          />
        ))
      )}
    </div>
  );

  return (
    <Accordion.Root
      activeItems={activeItems}
      onHandleActiveItems={setActiveItems}
      showArrow={true}
      className={styles.accordion}
    >
      <Accordion.Item
        id={ACCORDION_ACCEPTED_ID}
        headerClassName={styles["accordion-header"]}
        header={renderHeader(t("payfac.pagePendenciesCarouselAccepted"), accepted.length)}
      >
        {renderBody(accepted, t("payfac.pagePendenciesCarouselAccordionEmpty"), false)}
      </Accordion.Item>

      <Accordion.Item
        id={ACCORDION_SKIPPED_ID}
        headerClassName={styles["accordion-header"]}
        header={renderHeader(t("payfac.pagePendenciesCarouselSkipped"), skipped.length)}
      >
        {renderBody(skipped, t("payfac.pagePendenciesCarouselAccordionSkippedEmpty"), true)}
      </Accordion.Item>
    </Accordion.Root>
  );
};
